import * as Sentry from '@sentry/react';
import { Routes, createBrowserRouter } from 'react-router-dom';
import { TelemetryConfigsService } from '@csp/csp-common-telemetry';

const telemetryConfigs = TelemetryConfigsService.get();
const isSentryEnabled = telemetryConfigs.sentry?.enabled;

export const TelemetryRoutes = isSentryEnabled ? Sentry.withSentryReactRouterV6Routing(Routes) : Routes;

export const sentryCreateBrowserRouter = isSentryEnabled
  ? Sentry.wrapCreateBrowserRouter(createBrowserRouter)
  : createBrowserRouter;
